import errorReporter from '@app/errorReporter';

angular.module('bb.assets').component('bbVideoPlayerModal', {
  controller: VideoPlayerController,
  controllerAs: 'vm',
  template: require('./video_player_modal.html'),
});

VideoPlayerController.$inject = ['ModalService', 'AssetsService'];

function VideoPlayerController(ModalService, AssetsService) {
  const vm = this;

  vm.playerModal = ModalService.playerModal;

  vm.isEditing = false;

  vm.closeModal = () => {
    ModalService.closePlayerModal();
    vm.isEdting = false;
  };

  vm.onClickEditButton = () => {
    vm.isEditing = !vm.isEditing;
  };

  vm.saveVideoFileName = () => {
    const fileId = vm.playerModal.file.id;

    vm.isEditing = false;
    AssetsService.updateAssetFile(fileId, vm.playerModal.file.name)
      .then(() => {
        ModalService.closePlayerModal();
        vm.playerModal.updateFileName(fileId, vm.playerModal.file.name);
      })
      .catch(err => {
        errorReporter.error(err);
        vm.isEditing = true;
      });
  };
}
